import { render, staticRenderFns } from "./ListaBeneficiarios.vue?vue&type=template&id=1efa2480"
import script from "./ListaBeneficiarios.vue?vue&type=script&lang=js"
export * from "./ListaBeneficiarios.vue?vue&type=script&lang=js"
import style0 from "./ListaBeneficiarios.vue?vue&type=style&index=0&id=1efa2480&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports